import { PATH_IMAGES } from '../routes/paths';

export type ProductStatus = 'beta';
export type ProductLink = { label: string; href: string; ariaLabel: string };
export type ProductBrand = {
  main: string;
  hover: string;
  onMain: string;
};
export type Product = {
  id: string;
  index: number;
  name: string;
  url: string;
  status: ProductStatus;
  statusLabel: string;
  category: string;
  summary: string;
  brand: ProductBrand;
  logo: { src: string; width: number; height: number };
  primaryCta: ProductLink;
};

export const TONDTOND: Product = {
  id: 'tondtond',
  index: 1,
  name: 'TondTond',
  url: 'https://tondtond.com',
  status: 'beta',
  statusLabel: 'Beta · Free to try',
  category: 'Wishlists & gift registry for events',
  summary: 'Wishlists for birthdays, weddings and gatherings, shared with one link. Gift suggestions coming soon.',
  brand: {
    main: '#2065D1',
    hover: '#1D5BBD',
    onMain: '#FFFFFF',
  },
  logo: { src: `${PATH_IMAGES}/products/tondtond-logo.png`, width: 128, height: 128 },
  primaryCta: {
    label: 'Visit tondtond.com',
    href: 'https://tondtond.com',
    ariaLabel: 'Visit tondtond.com. TondTond is in beta and free to try.',
  },
};

export const WORLDSTAGE: Product = {
  id: 'worldstage',
  index: 2,
  name: 'Worldstage',
  url: 'https://worldstage.amiroamir.com',
  status: 'beta',
  statusLabel: 'Beta · Free to explore',
  category: 'An illustrated map of world politics',
  summary: 'See who runs each country, what they’re saying, and where nations clash or cooperate.',
  brand: {
    main: '#F0A73A',
    hover: '#E3992C',
    onMain: '#14120F',
  },
  logo: { src: `${PATH_IMAGES}/products/worldstage-logo.svg`, width: 64, height: 64 },
  primaryCta: {
    label: 'Explore the map',
    href: 'https://worldstage.amiroamir.com',
    ariaLabel: 'Explore the map at worldstage.amiroamir.com. Worldstage is in beta and free to explore.',
  },
};

export const PRODUCTS: Product[] = [TONDTOND, WORLDSTAGE];

export const ALLOWED_HREFS = [
  'https://tondtond.com',
  'https://tondtond.com/terms',
  'https://tondtond.com/contact',
  'https://worldstage.amiroamir.com',
  'https://www.cloudflare.com/privacypolicy/',
  'https://ico.org.uk/make-a-complaint/',
];

export function productHrefs(product: Product): string[] {
  return [product.url, product.primaryCta.href];
}

export function validateProducts(products: Product[]): string[] {
  const problems: string[] = [];

  products.forEach((p, i) => {
    if (i > 0 && p.index <= products[i - 1].index) {
      problems.push(`${p.id}: index ${p.index} is not unique and ascending`);
    }
    if (products.findIndex((q) => q.id === p.id) !== i) {
      problems.push(`${p.id}: id is not unique`);
    }
    productHrefs(p)
      .filter((href) => !ALLOWED_HREFS.includes(href))
      .forEach((href) => problems.push(`${p.id}: ${href} is not in ALLOWED_HREFS`));
  });

  return problems;
}

if (process.env.NODE_ENV === 'development') {
  validateProducts(PRODUCTS).forEach((problem) => console.error(problem));
}
